import { useForm } from "@mantine/form"
import { Button, InlineTextInput } from "@tfg/ui"
import { zod4Resolver } from "mantine-form-zod-resolver"

import {
  CreateOpChainDto,
  createOpChainSchema,
  OperationChainType,
  useCreateOpChainMutation,
} from "~/pages/Admin/Ingestion/OpChains/hooks/useCreateOpChainMutation"

type Props = {
  operationChainType: OperationChainType
}

export function OpChainCreation({ operationChainType }: Props) {
  const { mutate: createOpChain } = useCreateOpChainMutation()

  const form = useForm<CreateOpChainDto>({
    validate: zod4Resolver(createOpChainSchema),
    initialValues: {
      name: "",
      type: operationChainType,
    },
  })

  function handleSubmit(values: CreateOpChainDto) {
    createOpChain(values)
    form.reset()
  }

  return (
    <form onSubmit={form.onSubmit((values) => handleSubmit(values))}>
      <InlineTextInput
        {...form.getInputProps("name")}
        cta={
          <Button type="submit" disabled={!form.isValid()} fullWidth>
            Create
          </Button>
        }
        w="100%"
      />
    </form>
  )
}
